module.exports = __webpack_public_path__ + "img/p42.a80c51be.svg";